<template>
  <div>

    <p class="text-left text-sm leading-relaxed mt-4">
      The <a href="http://ihat.cyi.ac.cy">IH-AT platform</a> has been developed to enable non-technical users to quickly
      deploy, configure and visualize three-dimensional interactive scenes on the web. Through the proposed platform
      architecture, three-dimensional models are available online via the Potree viewer.
    </p>
    <p class="text-left text-sm leading-relaxed mt-4">
    The standard Potree Libraries
      (v1.7.2) were extended to create several custom-made interactive tools and allow the visualization of both 2D and
      3D data in the same web environment. Additionally, an admin panel was created and tailored to allow the
      customization of the front-end for different applications.
    </p>
    <p class="text-left text-sm leading-relaxed mt-4">
      The IH-AT platform is open-sourced, and it functions as a highly configurable application development framework
      that can:
    </p>
    <ul class="list-inside text-sm list-disc text-left mt-2">
      <li>dynamically handle multimedia files and 3D models,</li>
      <li>be adapted and extended according to the project’s needs,</li>
      <li>benefit of a large community of developers and users.</li>
    </ul>
    <p class="text-left text-sm leading-relaxed mt-4">
      The platform is open-sourced and aims to work as a higher-level development framework to support the easier
      development of interactive tools for 3D model visualization on the web.
      The IH-AT platform handles all the required processes for authorization and initialization purposes, isolating
      the steps needed to develop every single interactive tool.
      Docker.
    </p>
    <p class="text-left text-sm leading-relaxed mt-4">
      Authors:
      <ul class="list-inside list-disc">
        <li><a class="text-blue-500 hover:underline" href="https://www.cyi.ac.cy/index.php/starc/about-the-center/starc-our-people/author/277-dante-abate.html" target="_blank">Dante Abate</a></li>
        <li><a class="text-blue-500 hover:underline" href="https://www.cyi.ac.cy/index.php/starc/about-the-center/starc-our-people/itemlist/user/1107-kyriacos-toumbas.html" target="_blank">Kyriakos Toumbas</a></li>
        <li><a class="text-blue-500 hover:underline" href="https://www.cyi.ac.cy/index.php/cyi/general-information/administration-people/itemlist/user/172-marina-faka.html" target="_blank">Marina Faka</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: 'TabGeneral',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
